import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Pane, Text, PropertyGrid, TextInput, Selector, DateTimePicker, DateTimePickerV2 } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import classnames from 'classnames';
import CreateTemporaryUserModel from "../models/CreateTemporaryUser.js";
import S from './CreateTemporaryUserForm.css';
import Defaults from "./Defaults.js";
const {
  t
} = I18N.ns('temporaryUserManagement.CreateForm');

/**
 * Activate account screen.
 */
class CreateTemporaryUserForm extends React.Component {
  static propTypes = {
    expirationIntervals: PropTypes.array,
    defaultExpirationInterval: PropTypes.string,
    timezone: PropTypes.string,
    timeFormat: PropTypes.string,
    validIdPattern: PropTypes.instanceOf(RegExp)
  };
  static defaultProps = {
    expirationIntervals: Defaults.expirationIntervals,
    defaultExpirationInterval: Defaults.defaultExpirationInterval,
    timezone: Defaults.timezone,
    timeFormat: Defaults.timeFormat,
    validIdPattern: /^[a-zA-Z0-9]+$/
  };
  constructor(props) {
    super(props);
    // Get parameters
    this.state = {};
  }
  componentDidMount() {
    const {
      defaultExpirationInterval
    } = this.props;
    this.onExpirationIntervalChange({
      value: defaultExpirationInterval
    });
  }
  onChange = ({
    value,
    data
  }) => {
    const {
      onChange,
      value: fValue = CreateTemporaryUserModel.create()
    } = this.props;
    return onChange({
      value: CreateTemporaryUserModel[data](fValue, value)
    });
  };
  onExpirationIntervalChange = ({
    value,
    data
  }) => {
    const {
      onChange,
      value: fValue = CreateTemporaryUserModel.create()
    } = this.props;
    const {
      expirationIntervals
    } = this.props;
    const {
      expiresAt,
      validAfter
    } = expirationIntervals.find(ei => ei.name === value).value({
      ...fValue
    });
    const eSet = CreateTemporaryUserModel.setExpiresAt(fValue, expiresAt);
    const toSend = CreateTemporaryUserModel.setValidAfter(eSet, validAfter);
    this.setState({
      expirationInterval: value
    });
    onChange({
      value: toSend
    });
  };
  acceptIdChars = e => {
    const {
      validIdPattern
    } = this.props;
    return validIdPattern.test(e.key);
  };

  /**
   * Renders the component.
   */
  render() {
    // Get parameters
    const {
      getResourceName,
      value = CreateTemporaryUserModel.create(),
      roleSelector,
      expirationIntervals,
      timezone,
      timeFormat
    } = this.props;
    const {
      expirationInterval
    } = this.state;

    // Return component
    return /*#__PURE__*/React.createElement(PropertyGrid, {
      className: classnames(S.container, S.form, S.body),
      variant: "tempUserEditor|tempUser|userEditor|editor",
      vertical: true
    }, /*#__PURE__*/React.createElement(PropertyGrid.Header, {
      variant: "bodySmall",
      title: t('accessShare', {
        name: getResourceName?.() || 'a Device'
      })
    }), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      stretch: true,
      label: t('usernameLabel')
    }, /*#__PURE__*/React.createElement(Pane, {
      layout: "flexColS"
    }, /*#__PURE__*/React.createElement(TextInput, {
      acceptKey: this.acceptIdChars,
      className: S.input,
      value: CreateTemporaryUserModel.getId(value),
      onChange: this.onChange,
      eventData: "setId"
    }), /*#__PURE__*/React.createElement(Text, {
      variant: "inputCaption"
    }, t('usernameTooltip')))), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      stretch: true,
      label: t('descriptionLabel')
    }, /*#__PURE__*/React.createElement(TextInput, {
      className: S.input,
      value: CreateTemporaryUserModel.getDescription(value),
      onChange: this.onChange,
      eventData: "setDescription"
    })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      stretch: true,
      label: t('expiresAtLabel')
    }, /*#__PURE__*/React.createElement(Pane, {
      layout: "flexColS"
    }, /*#__PURE__*/React.createElement(Selector, {
      className: S.expirationInterval,
      values: expirationIntervals,
      value: expirationInterval,
      valueKey: "name",
      nameKey: "displayName",
      onChange: this.onExpirationIntervalChange
    }), /*#__PURE__*/React.createElement(Text, {
      variant: "inputCaption"
    }, t('linkExpires', {
      expiresAt: new Date(CreateTemporaryUserModel.getExpiresAt(value)),
      validAfter: new Date(CreateTemporaryUserModel.getValidAfter(value))
    })))), expirationInterval === 'custom' ? [/*#__PURE__*/React.createElement(PropertyGrid.Item, {
      stretch: true,
      label: t('startDate')
    }, /*#__PURE__*/React.createElement(DateTimePickerV2, {
      timezone: timezone,
      className: S.dtp,
      value: new Date(CreateTemporaryUserModel.getValidAfter(value)),
      onChange: this.onChange,
      eventData: "setValidAfter"
    })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
      stretch: true,
      label: t('endDate')
    }, /*#__PURE__*/React.createElement(DateTimePickerV2, {
      timezone: timezone,
      className: S.dtp,
      value: new Date(CreateTemporaryUserModel.getExpiresAt(value)),
      onChange: this.onChange,
      eventData: "setExpiresAt"
    }))] : null, /*#__PURE__*/React.isValidElement(roleSelector) && /*#__PURE__*/React.createElement("div", {
      className: S.gridItem
    }, roleSelector));
  }
}

/* Export and Connect Module */
export default connect(state => {
  return {
    auth: state.auth
  };
})(CreateTemporaryUserForm);